var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.762,13.9512414 C27.762,21.5088276 21.6348276,27.636 14.0772414,27.636 C6.51917241,27.636 0.392482759,21.5088276 0.392482759,13.9512414 C0.392482759,6.39365517 6.51917241,0.266482759 14.0772414,0.266482759 C21.6348276,0.266482759 27.762,6.39365517 27.762,13.9512414 L27.762,13.9512414 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag-popup",
    transform: "translate(-387.000000, -500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(386.000000, 499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-800",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-790"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-789",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "0.392482759 27.6350345 27.762 27.6350345 27.762 0.266965517 0.392482759 0.266965517"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-791",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "-6.44917241 18.5722069 -6.44917241 24.29 2.32255172 18.5722069 -6.44917241 18.5722069"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-792",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "-6.44917241 3.77082759 -6.44917241 9.33124138 2.08165517 9.33124138 -6.44917241 3.77082759"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-793",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "30.3693793 0.266965517 17.8345517 0.266965517 17.8345517 8.43717241 30.3693793 0.266965517"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-794",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "10.319931 0.266965517 -2.34813793 0.266965517 10.319931 8.52503448 10.319931 0.266965517"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-795",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "-2.1057931 27.6355172 10.319931 27.6355172 10.319931 19.5357931 -2.1057931 27.6355172"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-796",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "34.6046207 9.33124138 34.6046207 3.68296552 25.9395862 9.33124138 34.6046207 9.33124138"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-797",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "17.8345517 27.6355172 30.1270345 27.6355172 17.8345517 19.6226897 17.8345517 27.6355172"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-798",
    fill: "#002377",
    mask: "url(#mask-2)",
    points: "34.6046207 24.3768966 34.6046207 18.5722069 25.6986897 18.5722069 34.6046207 24.3768966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2018621,11.2873793 L34.6046207,11.2873793 L34.6046207,16.6151034 L16.2018621,16.6151034 L16.2018621,27.6355172 L11.9526207,27.6355172 L11.9526207,16.6151034 L-6.45013793,16.6151034 L-6.45013793,11.2873793 L11.9526207,11.2873793 L11.9526207,0.266965517 L16.2018621,0.266965517 L16.2018621,11.2873793 Z M-6.44917241,27.3598621 L-6.44917241,27.6355172 L-3.68875862,27.6355172 L10.218069,18.5712414 L7.0337931,18.5712414 L-6.44917241,27.3598621 Z M31.9581379,0.266965517 L18.0522759,9.33124138 L21.2365517,9.33124138 L34.6046207,0.616965517 L34.6046207,0.266965517 L31.9581379,0.266965517 Z M21.0270345,18.5712414 L34.6046207,27.4202069 L34.6046207,25.3457931 L24.2113103,18.5712414 L21.0270345,18.5712414 Z M6.96475862,9.33124138 L-6.44917241,0.587517241 L-6.44917241,2.66289655 L3.78048276,9.33124138 L6.96475862,9.33124138 L6.96475862,9.33124138 Z",
    id: "Fill-799",
    fill: "#C2121F",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.b0ed7a94ae5ef4d69f7ae505b2449071.svg";
export { ForwardRef as ReactComponent };